"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledInnerCardTitle = exports.StyledInnerCardRightSection = exports.StyledInnerCardMiddleSection = exports.StyledInnerCardLeftSection = exports.StyledInnerCardInfoValue = exports.StyledInnerCardInfoKey = exports.StyledInnerCardInfo = exports.StyledInnerCardImg = exports.StyledInnerCardDiv = exports.StyledFlexibleCardTitle = exports.StyledFlexibleCardDiv = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _shared = require("../../../shared");

var _utils = require("../../../shared/utils");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

const StyledInnerCardDivBorderColor = (0, _utils.hexToRgba)(_shared.theme.palette.brand.primary.gray, 0.5);

const StyledFlexibleCardDiv = _styledComponents.default.div.withConfig({
  displayName: "style__StyledFlexibleCardDiv",
  componentId: "sc-t1tl2p-0"
})(["display:flex;flex-direction:column;align-items:flex-start;padding:24px 30px;max-width:", ";min-width:337px;border:", ";border-radius:4px;", ""], ({
  width
}) => width ? width : '337px', ({
  showBorder
}) => showBorder ? `1px solid ${_shared.theme.palette.ui.neutral.grey4}` : 'none', ({
  background
}) => background && `background: ${background}`);

exports.StyledFlexibleCardDiv = StyledFlexibleCardDiv;

const StyledFlexibleCardTitle = _styledComponents.default.p.withConfig({
  displayName: "style__StyledFlexibleCardTitle",
  componentId: "sc-t1tl2p-1"
})(["", ";margin:0;"], _shared.theme.typography.body.css);

exports.StyledFlexibleCardTitle = StyledFlexibleCardTitle;

const StyledInnerCardDiv = _styledComponents.default.div.withConfig({
  displayName: "style__StyledInnerCardDiv",
  componentId: "sc-t1tl2p-2"
})(["border-bottom:1px solid rgba( ", ",", ",", ",", " );display:flex;justify-content:space-between;align-items:flex-start;padding-top:17px;padding-bottom:22px;width:", ";max-width:", ";min-width:337px;&:last-child{border:none;}"], StyledInnerCardDivBorderColor.red, StyledInnerCardDivBorderColor.green, StyledInnerCardDivBorderColor.blue, StyledInnerCardDivBorderColor.opacity, ({
  width
}) => width ? width : '337px', ({
  width
}) => width ? width : '337px');

exports.StyledInnerCardDiv = StyledInnerCardDiv;

const StyledInnerCardTitle = _styledComponents.default.div.withConfig({
  displayName: "style__StyledInnerCardTitle",
  componentId: "sc-t1tl2p-3"
})(["", ";padding-bottom:3px;"], _shared.theme.typography.h6.css);

exports.StyledInnerCardTitle = StyledInnerCardTitle;

const StyledInnerCardLeftSection = _styledComponents.default.div.withConfig({
  displayName: "style__StyledInnerCardLeftSection",
  componentId: "sc-t1tl2p-4"
})(["min-width:34px;display:", ";"], ({
  showImage
}) => showImage ? 'block' : 'none');

exports.StyledInnerCardLeftSection = StyledInnerCardLeftSection;

const StyledInnerCardImg = _styledComponents.default.img.withConfig({
  displayName: "style__StyledInnerCardImg",
  componentId: "sc-t1tl2p-5"
})(["width:34px;height:34px;object-fit:contain;display:", ";align-items:center;"], ({
  src
}) => src ? 'block' : 'none');

exports.StyledInnerCardImg = StyledInnerCardImg;

const StyledInnerCardMiddleSection = _styledComponents.default.div.withConfig({
  displayName: "style__StyledInnerCardMiddleSection",
  componentId: "sc-t1tl2p-6"
})(["min-width:228px;"]);

exports.StyledInnerCardMiddleSection = StyledInnerCardMiddleSection;

const StyledInnerCardInfo = _styledComponents.default.div.withConfig({
  displayName: "style__StyledInnerCardInfo",
  componentId: "sc-t1tl2p-7"
})(["@keyframes show{from{opacity:0;}to{opacity:1;}}", ";padding-bottom:3px;animation:show 0.5s ease-in-out both;&.shouldHideShow{display:", ";}&:last-child{padding-bottom:0;}"], _shared.theme.typography.h6.css, ({
  expanded
}) => expanded ? 'block' : 'none');

exports.StyledInnerCardInfo = StyledInnerCardInfo;

const StyledInnerCardInfoKey = _styledComponents.default.span.withConfig({
  displayName: "style__StyledInnerCardInfoKey",
  componentId: "sc-t1tl2p-8"
})(["", ";color:", ";"], _shared.theme.typography.h6.css, _shared.theme.palette.brand.primary.gray);

exports.StyledInnerCardInfoKey = StyledInnerCardInfoKey;

const StyledInnerCardInfoValue = _styledComponents.default.span.withConfig({
  displayName: "style__StyledInnerCardInfoValue",
  componentId: "sc-t1tl2p-9"
})(["", ";"], _shared.theme.typography.h6.css);

exports.StyledInnerCardInfoValue = StyledInnerCardInfoValue;

const StyledInnerCardRightSection = _styledComponents.default.div.withConfig({
  displayName: "style__StyledInnerCardRightSection",
  componentId: "sc-t1tl2p-10"
})(["display:flex;transition:all 0.3s ease-in-out;transform-origin:center center;", ";"], ({
  expanded
}) => expanded && `transform: rotateZ(-180deg);`);

exports.StyledInnerCardRightSection = StyledInnerCardRightSection;